import Vue from 'vue';

function tenantApiDomain() {
    return Vue.prototype.$auth.session.org_uri + '/api'
}

export default tenantApiDomain;